export enum AUTH_REQUEST {
  LOGOUT = 'logout',
  REFRESH = 'refresh',
  SET_PASSWORD = 'setPassword',
}

export enum PERMISSIONS {
  CAN_ACTIVATE_CASCADING_SCHEMA = 'activate.cascading.schema',
  CAN_ACTIVATE_CUSTOMER_PAYMENT_INSTRUMENTS = 'activate.client.payout.payment.instrument',

  CAN_ACTIVATE_ROUTING_SCHEMA = 'activate.routing.schema',

  CAN_BLOCK_USER = 'block.user',
  CAN_BULK_COPY_CHANGE_RULES = 'bulk.copy.change.rules',
  CAN_BULK_COPY_RULESETS = 'bulk.copy.rulesets',
  CAN_BULK_CREATE_CHANGE_RULE = 'bulk.create.change.rule',
  CAN_BULK_CREATE_RESULT_CODES = 'bulk.create.result.code.mapping',
  CAN_CHANGE_HF_STYLIZATION = 'update.hpf.iframe.stylization',
  CAN_CHANGE_MP_STYLIZATION = 'update.organization.theme',
  CAN_CHANGE_PAYMENT_METHODS_PAGE = 'update.payment.methods.page.stylization',

  CAN_CHANGE_PAYMENT_PAGE_STYLIZATION = 'update.payment.page.stylization',
  CAN_CHANGE_TRANSACTIONS_STATUS_PAGE = 'update.transaction.status.page.stylization',
  CAN_COPY_DASHBOARD_FOLDER = 'copy.dashboard.folder',
  CAN_COPY_PAYMENT_PAGE_STYLIZATION = 'copy.payment.page.stylization',
  CAN_COPY_PSP_PARAMETER = 'copy.bank.parameter',

  CAN_COPY_RULESETS_TO_MERCHANT = 'copy.rulesets.to.merchant',
  CAN_COPY_TERMINAL_LINK_LIMITS = 'copy.terminal.link.limits',
  CAN_COPY_TERMINAL_LINKS = 'copy.terminal.links',
  CAN_CREATE_API_USERS = 'create.api.user',
  CAN_CREATE_BANK_TERMINAL = 'create.bank.terminal',

  CAN_CREATE_BANKS_REPORTS = 'create.banks.reports',
  CAN_CREATE_BILLING_CONTRACT = 'create.billing.contract',
  CAN_CREATE_BLACKLISTS_CARD_MASKS_REPORTS = 'create.blacklist.cm.reports',
  CAN_CREATE_BLACKLISTS_CM = 'create.blacklist.cm',

  CAN_CREATE_BLACKLISTS_DEVICE = 'create.blacklist.fp',
  CAN_CREATE_BLACKLISTS_EMAIL = 'create.blacklist.em',
  CAN_CREATE_BLACKLISTS_EMAIL_REPORTS = 'create.blacklist.em.reports',
  CAN_CREATE_BLACKLISTS_IP = 'create.blacklist.ip',

  CAN_CREATE_BLACKLISTS_IP_REPORTS = 'create.blacklist.ip.reports',
  CAN_CREATE_CASCADING_SCHEMA = 'create.cascading.schema',

  CAN_CREATE_CASHIER_LIMITS_REPORTS = 'create.cashier.limits.reports',

  CAN_CREATE_CASHIER_PAYMENT_LIMIT = 'create.cashier.limit',
  CAN_CREATE_CASHIER_PAYMENT_METHOD = 'create.cashier.payment.method',
  CAN_CREATE_CASHIER_PAYMENT_METHOD_GROUPS = 'create.cashier.payment.method.groups',
  CAN_CREATE_CASHIER_PAYMENT_METHODS_REPORTS = 'create.cashier.payment.methods.reports',

  CAN_CREATE_CASHIER_SETTING = 'create.cashier.setting',
  CAN_CREATE_CASHIER_SETTINGS_REPORTS = 'create.cashier.settings.reports',
  CAN_CREATE_CLIENT = 'create.client',

  CAN_CREATE_CASHIER_PAYMENT_METHOD_LOCALISATION = 'create.cashier.payment.method.localisation',
  CAN_DELETE_CASHIER_PAYMENT_METHOD_LOCALISATION = 'delete.cashier.payment.method.localisation',
  CAN_UPDATE_CASHIER_PAYMENT_METHOD_LOCALISATION = 'update.cashier.payment.method.localisation',
  CAN_VIEW_CASHIER_PAYMENT_METHOD_LOCALISATION = 'view.cashier.payment.method.localisation',

  CAN_CREATE_CHANGE_RULE = 'create.change.rule',
  CAN_DELETE_CHANGE_RULE = 'delete.change.rule',
  CAN_UPDATE_CHANGE_RULE = 'update.change.rule',
  CAN_VIEW_CHANGE_RULES = 'view.change.rules',

  CAN_CREATE_BIN_GROUP = 'create.bin.group',
  CAN_CREATE_CLIENT_ACPM = 'create.client.acpm',
  CAN_CREATE_CLIENT_PRIORITY_RULESETS = 'create.customer.priority.rulesets',
  CAN_CREATE_CLIENTS_INSTRUMENTS_REPORTS = 'create.clients.instruments.reports',
  CAN_CREATE_CLIENTS_REPORTS = 'create.clients.reports',
  CAN_CREATE_COUNTRY_GROUPS = 'create.country.group',
  CAN_CREATE_CUSTOMER_LIMIT = 'create.customer.limit',

  CAN_CREATE_CUSTOMER_PAGE_LIMIT = 'create.customer.payment.method.limit',
  CAN_CREATE_DASHBOARD = 'create.dashboard',
  CAN_CREATE_DASHBOARD_FOLDER = 'create.dashboard.folder',
  CAN_CREATE_GATEWAY_INVOICE = 'create.gateway.invoice',
  CAN_CREATE_GATEWAY_INVOICE_DETAILS_REPORTS = 'create.gateway.invoice.details.reports',

  CAN_CREATE_GATEWAY_INVOICE_REPORTS = 'create.gateway.invoice.reports',
  CAN_CREATE_GRAPH = 'create.graph',
  CAN_CREATE_MANUAL_PAYOUT = 'create.manual.payout',
  CAN_CREATE_MANUAL_REFUND = 'create.manual.refund',

  CAN_CREATE_MANUAL_TRANSACTION = 'create.manual.transaction',
  CAN_CREATE_MERCHANT = 'create.merchant.terminal',
  CAN_CREATE_MERCHANT_CUSTOMER_LIMIT = 'create.merchant.customer.limit',
  CAN_CREATE_MERCHANT_TERMINAL_REPORTS = 'create.merchant.terminal.reports',

  CAN_CREATE_MERCHANT_GROUPS = 'create.merchant.group',
  CAN_CREATE_METADATA_TEMPLATE = 'create.routing.ruleset.metadata.template',
  CAN_CREATE_NOTIFICATION = 'create.notification',
  CAN_CREATE_OUTPUT_CHANNELS = 'create.notifications.output.channel',
  CAN_CREATE_PAYMENT_LINKS = 'create.direct.payment.link',

  CAN_CREATE_HF_STYLIZATION = 'create.hpf.iframe.stylization',
  CAN_CREATE_PAYMENT_PAGE_STYLIZATION = 'create.payment.page.stylization',

  CAN_CREATE_PSP = 'create.bank',
  CAN_CREATE_PSP_PARAMETER = 'create.bank.parameter',
  CAN_CREATE_PSP_TERMINAL_PARAMETER = 'create.bank.terminal.parameter',
  CAN_CREATE_RESULT_CODE = 'create.result.code.mapping',
  CAN_CREATE_ROUTING_SCHEMA = 'create.routing.schema',
  CAN_CREATE_RULESET = 'create.ruleset',
  CAN_CREATE_RULESET_REPORTS = 'create.rulesets.reports',
  CAN_CREATE_RULESET_STATS = 'create.ruleset.stats',

  CAN_CREATE_SETTLEMENT_CONTRACT = 'create.settlement.contract',

  CAN_CREATE_SETTLEMENT_CONTRACTS_WORKBOOK_REPORTS = 'create.settlement.contract.workbook.reports',
  CAN_CREATE_TEMPLATE = 'create.notifications.message.templates',
  CAN_CREATE_TERMINAL_LINK = 'create.terminal.link',
  CAN_CREATE_TERMINAL_LINK_PARAMETER = 'create.terminal.link.parameter',

  CAN_CREATE_TERMINAL_LINK_SETTLEMENT_CONFIG = 'create.terminal.link.settlement.config',
  CAN_CREATE_TERMINAL_LINKS_ACTIONS = 'create.terminal.link.action',
  CAN_CREATE_TERMINAL_LINKS_GROUPS = 'create.terminal.links.group',
  CAN_CREATE_TERMINAL_LINKS_LIMIT = 'create.terminal.link.limit',
  CAN_CREATE_TERMINAL_LINKS_PARAMETERS_REPORTS = 'create.tl.parameters.reports',

  CAN_CREATE_TERMINAL_LINKS_REPORTS = 'create.terminal.links.reports',
  CAN_CREATE_TERMINAL_OUTPUT_CHANNELS = 'create.mt.notifications.output.channel',
  CAN_CREATE_TRANSACTION_REPORTS = 'create.transaction.reports',
  CAN_CREATE_USER = 'create.user',

  CAN_DELETE_API_USERS = 'delete.api.user',
  CAN_DELETE_BANK_TERMINAL = 'delete.bank.terminal',

  CAN_DELETE_BILLING_CONTRACT = 'delete.billing.contract',
  CAN_DELETE_BLACKLISTS_CARD_MASKS = 'delete.blacklist.cm',
  CAN_DELETE_BLACKLISTS_DEVICE = 'delete.blacklist.fp',

  CAN_DELETE_BLACKLISTS_EMAIL = 'delete.blacklist.em',
  CAN_DELETE_BLACKLISTS_IP = 'delete.blacklist.ip',
  CAN_DELETE_CASCADING_SCHEMA = 'delete.cascading.schema',
  CAN_DELETE_CASHIER_PAYMENT_LIMIT = 'delete.cashier.limit',

  CAN_DELETE_CASHIER_PAYMENT_METHOD = 'delete.cashier.payment.method',
  CAN_DELETE_CASHIER_PAYMENT_METHOD_GROUPS = 'delete.cashier.payment.method.groups',
  CAN_DELETE_CASHIER_SETTING = 'delete.cashier.setting',

  CAN_DELETE_BIN_GROUP = 'delete.bin.group',
  CAN_DELETE_CLIENT_ACPM = 'delete.client.acpm',
  CAN_DELETE_CLIENT_PRIORITY_RULESETS = 'delete.customer.priority.rulesets',
  CAN_DELETE_COUNTRY_GROUPS = 'delete.country.group',
  CAN_DELETE_CUSTOMER_LIMIT = 'delete.customer.limit',
  CAN_DELETE_CUSTOMER_PAGE_LIMIT = 'delete.customer.payment.method.limit',
  CAN_DELETE_DASHBOARD = 'delete.dashboard',
  CAN_DELETE_DASHBOARD_FOLDER = 'delete.dashboard.folder',
  CAN_DELETE_FULL_MERCHANT = 'full.delete.merchant.terminal',
  CAN_DELETE_GATEWAY_INVOICE = 'delete.gateway.invoice',
  CAN_DELETE_GRAPH = 'delete.graph',
  CAN_DELETE_GROUP_LIMIT = 'delete.group.limit',
  CAN_DELETE_MERCHANT = 'delete.merchant.terminal',
  CAN_DELETE_MERCHANT_CUSTOMER_LIMIT = 'delete.merchant.customer.limit',

  CAN_DELETE_MERCHANT_GROUPS = 'delete.merchant.group',
  CAN_DELETE_METADATA_TEMPLATE = 'delete.routing.ruleset.metadata.template',
  CAN_DELETE_NOTIFICATION = 'delete.notification',
  CAN_DELETE_OUTPUT_CHANNELS = 'delete.notifications.output.channel',

  CAN_DELETE_HF_STYLIZATION = 'delete.hpf.iframe.stylization',
  CAN_DELETE_PAYMENT_LINKS = 'delete.direct.payment.link',
  CAN_DELETE_PAYMENT_PAGE_STYLIZATION = 'delete.payment.page.stylization',
  CAN_DELETE_PERMISSION_PICTURE = 'delete.permission.picture',
  CAN_DELETE_PSP = 'delete.bank',
  CAN_DELETE_PSP_PARAMETER = 'delete.bank.parameter',
  CAN_DELETE_PSP_TERMINAL_PARAMETER = 'delete.bank.terminal.parameter',
  CAN_DELETE_RESULT_CODE = 'delete.result.code.mapping',
  CAN_DELETE_ROUTING_SCHEMA = 'delete.routing.schemas',
  CAN_DELETE_RULESET = 'delete.ruleset',
  CAN_DELETE_SETTLEMENT_CONTRACT = 'delete.settlement.contract',
  CAN_DELETE_TEMPLATE = 'delete.notifications.message.templates',
  CAN_DELETE_TERMINAL_LINK = 'delete.terminal.link',
  CAN_DELETE_TERMINAL_LINK_LIMIT = 'delete.terminal.link.limit',
  CAN_DELETE_TERMINAL_LINKS_ACTIONS = 'delete.terminal.link.action',
  CAN_DELETE_TERMINAL_LINKS_GROUPS = 'delete.links.group',

  CAN_DELETE_TERMINAL_OUTPUT_CHANNELS = 'delete.mt.notifications.output.channel',
  DELETE_ADAPTER_CODE = 'delete.builder.adapter.code',

  CAN_DELETE_USER = 'delete.user',
  CAN_DISABLE_MERCHANT = 'disable.merchant.terminal',
  CAN_EDIT_BIN_GROUP = 'update.bin.group',
  CAN_EDIT_COUNTRY_GROUPS = 'update.country.group',
  CAN_EDIT_METADATA_TEMPLATE = 'update.routing.ruleset.metadata.template',
  CAN_GROUP_CREATE_TERMINAL_LINK_SETTLEMENT_CONFIGS = 'group.create.terminal.link.settlement.config',

  CAN_GROUP_DELETE_TERMINAL_LINK_SETTLEMENT_CONFIG = 'group.delete.terminal.link.settlement.config',
  CAN_GROUP_EDIT_CASHIER_LIMITS = 'group.edit.cashier.limits',
  CAN_GROUP_EDIT_CASHIER_PAYMENT_METHOD = 'group.edit.cashier.payment.method',
  CAN_GROUP_EDIT_CASHIER_SETTINGS = 'group.edit.cashier.settings',
  CAN_GROUP_EDIT_GROUP_LIMITS = 'group.edit.group.limits',
  CAN_GROUP_EDIT_MERCHANT_TERMINALS = 'group.edit.merchant.terminals',
  CAN_GROUP_EDIT_RESULT_CODES = 'group.edit.result.code.mapping',

  CAN_GROUP_EDIT_RULESETS = 'group.edit.rulesets',
  CAN_GROUP_EDIT_TERMINAL_LINK_LIMITS = 'group.edit.terminal.link.limits',
  CAN_GROUP_EDIT_TERMINAL_LINK_REQUIRED_PARAMETERS = 'group.edit.terminal.link.required.parameters.configuration',
  CAN_GROUP_EDIT_TERMINAL_LINKS = 'update.terminal.links',
  CAN_GROUP_EDIT_TERMINAL_LINKS_PARAMETERS = 'group.edit.terminal.links.parameters',
  CAN_MERGE_EDIT_RULESETS = 'bulk.merge.rulesets',
  CAN_REVERT_RULESETS = 'revert.rulesets',

  CAN_GROUP_UPDATE_TERMINAL_LINK_SETTLEMENT_CONFIG = 'group.update.terminal.link.settlement.config',
  CAN_SET_ACTIVE_HF_STYLIZATION = 'set.hpf.iframe.stylization',
  CAN_SET_ACTIVE_PAYMENT_PAGE_STYLIZATION = 'set.active.payment.page.stylization',
  CAN_SYNC_USERS = 'sync.users',
  CAN_UPDATE_API_USERS = 'update.api.user',
  CAN_UPDATE_BANK_TERMINAL = 'update.bank.terminal',
  CAN_UPDATE_BILLING_CONTRACT = 'update.billing.contract',
  CAN_UPDATE_CASCADING_SCHEMA = 'update.cascading.schema',
  CAN_UPDATE_CASHIER_PAYMENT_LIMIT = 'update.cashier.limit',
  CAN_UPDATE_CASHIER_PAYMENT_METHOD = 'update.cashier.payment.method',
  CAN_UPDATE_CASHIER_PAYMENT_METHOD_GROUPS = 'update.cashier.payment.method.groups',
  CAN_UPDATE_CASHIER_SETTING = 'update.cashier.setting',
  CAN_UPDATE_CLIENT = 'update.client',
  CAN_UPDATE_CLIENT_PRIORITY_RULESETS = 'update.customer.priority.rulesets',

  CAN_CREATE_DEFINITIONS = 'create.definition',
  CAN_DELETE_DEFINITIONS = 'delete.definition',
  CAN_UPDATE_DEFINITIONS = 'update.definition',
  CAN_VIEW_DEFINITIONS = 'view.definitions',

  CAN_RECALCULATE_CLIENT_STATS = 'recalculate.client.stats',
  CAN_UPDATE_CUSTOMER_LIMIT = 'update.customer.limit',
  CAN_UPDATE_CUSTOMER_PAGE_LIMIT = 'update.customer.payment.method.limit',
  CAN_UPDATE_DASHBOARD = 'update.dashboard',
  CAN_UPDATE_DASHBOARD_FOLDER = 'update.dashboard.folder',
  CAN_UPDATE_GATEWAY_INVOICE = 'update.gateway.invoice',
  CAN_UPDATE_GRAPH = 'update.graph',

  CAN_UPDATE_GROUP_LIMIT = 'update.group.limit',
  CAN_UPDATE_GROUP_RULESETS = 'update.rulesets',
  CAN_UPDATE_MERCHANT = 'update.merchant.terminal.mv',
  CAN_UPDATE_MERCHANT_ANTIFRAUD = 'update.merchant.terminal.antifraud',
  CAN_UPDATE_MERCHANT_API_ACCESS_MODE = 'update.merchant.terminal.api-access-mode',
  CAN_UPDATE_MERCHANT_CARD_TOKEN = 'update.merchant.terminal.card-token',

  CAN_UPDATE_MERCHANT_CUSTOMER_LIMIT = 'update.merchant.customer.limit',
  CAN_UPDATE_MERCHANT_GROUPS = 'update.merchant.group',
  CAN_UPDATE_MERCHANT_LEGAL_ENTITY = 'update.merchant.terminal.legal-entity',
  CAN_UPDATE_MERCHANT_MOTO = 'update.merchant.terminal.moto',

  CAN_UPDATE_MERCHANT_NAME = 'update.merchant.terminal.name',
  CAN_UPDATE_MERCHANT_ORGANIZATION = 'transfer.merchant.terminal',
  CAN_UPDATE_MERCHANT_RESTRICTED_COUNTRIES = 'update.merchant.terminal.restricted-countries',
  CAN_UPDATE_MERCHANT_SHOP_URL = 'update.merchant.terminal.shop-url',

  CAN_UPDATE_MERCHANT_WEBHOOK_CARDHOLDER = 'update.merchant.terminal.webhook-cardholder',
  CAN_UPDATE_MERCHANT_WEBHOOK_EXP_DATE = 'update.merchant.terminal.webhook-exp-date',
  CAN_UPDATE_NOTIFICATION = 'update.notification',
  CAN_UPDATE_OUTPUT_CHANNELS = 'update.notifications.output.channel',

  CAN_UPDATE_PAYMENT_LINKS = 'update.direct.payment.link',
  CAN_UPDATE_PAYMENT_LINKS_NON_CASHIER_PM = 'update.direct.payment.link.non-cashier.payment.methods',
  CAN_UPDATE_PAYMENT_PAGE_STYLIZATION = 'update.merchant.portal.stylization',
  CAN_UPDATE_PERMISSION_PICTURE = 'update.permission.picture',

  CAN_UPDATE_PSP = 'update.bank',
  CAN_UPDATE_PSP_PARAMETER = 'update.bank.parameter',
  CAN_UPDATE_PSP_TERMINAL_PARAMETER = 'update.bank.terminal.parameter',
  CAN_UPDATE_RESULT_CODE = 'update.result.code.mapping',

  CAN_UPDATE_ROUTING_SCHEMA = 'update.routing.schema',
  CAN_UPDATE_RULESET = 'update.ruleset',
  CAN_UPDATE_RULESET_STATS = 'update.ruleset.stats',
  CAN_UPDATE_SETTLEMENT_CONTRACT = 'update.settlement.contract',

  CAN_UPDATE_SETTLEMENT_CONTRACTS_WORKBOOK = 'update.settlement.contracts.workbook',
  CAN_UPDATE_SINGLE_TRANSACTION = 'update.single.transaction',
  CAN_UPDATE_TEMPLATE = 'update.notifications.message.templates',

  CAN_UPDATE_TERMINAL_LINK = 'update.terminal.link',
  CAN_UPDATE_TERMINAL_LINK_PARAMETER = 'update.terminal.link.parameter',
  CAN_UPDATE_TERMINAL_LINK_REQUIRED_PARAMETERS = 'update.terminal.link.required.parameters.configuration',
  CAN_UPDATE_TERMINAL_LINK_REQUIRED_PARAMETERS_MODIFY = 'update.terminal.link.required.parameters.configuration.vm',
  CAN_UPDATE_TERMINAL_LINKS_ACTIONS = 'update.terminal.link.action',
  CAN_UPDATE_TERMINAL_LINKS_GROUPS = 'update.terminal.link.group',

  CAN_CREATE_BLACKLISTS_CARDS_PANS = 'create.blacklist.card',
  CAN_DELETE_BLACKLISTS_CARDS_PANS = 'delete.blacklist.card',
  CAN_UPDATE_TERMINAL_LINKS_LIMIT = 'update.terminal.link.limit',
  CAN_UPDATE_TERMINAL_LINKS_TL_GROUPS = 'update.links.group',
  CAN_UPDATE_TERMINAL_OUTPUT_CHANNELS = 'update.mt.notifications.output.channel',
  CAN_UPDATE_USER = 'update.user',
  CAN_VERIFY_TERMINAL_OUTPUT_CHANNELS = 'verify.mt.output.channel',
  CAN_VIEW_API_USERS = 'view.api.users',
  CAN_VIEW_BILLING_CONTRACTS = 'view.billing.contracts',
  CAN_VIEW_BLACKLISTS_CARD_MASKS = 'view.blacklist.cm',
  CAN_VIEW_BLACKLISTS_CARDS_PANS = 'view.blacklist.card',
  CAN_VIEW_BLACKLISTS_DEVICES = 'view.blacklist.fp',
  UPDATE_ADAPTER_CODE = 'update.builder.adapter.code',

  CAN_VIEW_MESSAGE_CENTER = 'view.message.center',

  CAN_VIEW_BLACKLISTS_EMAILS = 'view.blacklist.em',
  CAN_VIEW_BLACKLISTS_IP = 'view.blacklist.ip',
  CAN_VIEW_CASCADING_SCHEMAS = 'view.cascading.schemas',
  CAN_VIEW_CASHIER_PAYMENT_LIMITS = 'view.cashier.limits',
  CAN_VIEW_CASHIER_PAYMENT_METHODS = 'view.cashier.payment.methods',
  CAN_VIEW_CASHIER_PAYMENT_METHODS_GROUPS = 'view.cashier.payment.method.groups',
  CAN_VIEW_CASHIER_SETTINGS = 'view.cashier.settings',

  CAN_VIEW_CHARGEBACK_STATISTICS = 'view.chargeback.statistics',

  CAN_VIEW_CLARITY_RECORDINGS = 'view.clarity.recordings',

  CAN_VIEW_CLIENT_ACPM = 'view.client.acpms',

  CAN_MANAGE_CLIENT_ROUTING_PRIORITIES = 'client.routing.priorities',

  CAN_DELETE_SAVED_PAYMENT_TOKEN = 'delete.saved.payment.token',
  CAN_UPDATE_SAVED_PAYMENT_TOKEN = 'update.saved.payment.token',
  CAN_VIEW_SAVED_PAYMENT_METHOD = 'view.saved.payment.token',

  CAN_VIEW_BIN_GROUPS = 'view.bin.groups',
  CAN_VIEW_CLIENT_PRIORITY_RULESETS = 'view.customer.priority.rulesets',
  CAN_VIEW_CLIENTS = 'view.clients',
  CAN_VIEW_COUNTRY_GROUPS = 'view.country.groups',
  CAN_VIEW_CUSTOMER_LIMITS = 'view.customer.limit',

  CAN_VIEW_CUSTOMER_PAGE_LIMITS = 'view.customer.payment.method.limit',
  CAN_VIEW_CUSTOMER_PAYMENT_INSTRUMENTS = 'view.client.payment.instruments',
  CAN_VIEW_CUSTOMER_ROUTING_STATS = 'routing.client.stats',
  CAN_VIEW_DASHBOARD_FOLDERS = 'view.dashboard.folders',

  CAN_VIEW_DASHBOARDS = 'view.dashboards',
  CAN_VIEW_DESCRIPTIONS_TERMINAL_LINK = 'view.descriptions.terminal.link',
  CAN_VIEW_DETAILED_ROLE_SCOPE = 'view.detailed.role.scope',
  CAN_VIEW_GATEWAY_INVOICES = 'view.gateway.invoices',

  CAN_VIEW_GRAPHS = 'view.graphs',
  CAN_VIEW_KIBANA_LOGS = 'view.kibana.logs',

  CAN_VIEW_MERCHANT_CUSTOMER_LIMIT = 'view.merchant.customer.limit',
  CAN_VIEW_MERCHANT_GROUP_NAMES = 'view.merchant.group.names',
  CAN_VIEW_MERCHANT_GROUPS = 'view.merchant.group',
  CAN_VIEW_MERCHANT_SECRET_KEY = 'view.merchant.terminal.secret-key',
  CAN_VIEW_MERCHANTS = 'view.merchant.terminals',
  CAN_VIEW_METADATA_TEMPLATES = 'view.routing.ruleset.metadata.templates',

  CAN_VIEW_HF_STYLIZATIONS = 'view.hpf.iframe.stylizations',
  CAN_VIEW_NOTIFICATIONS = 'view.notifications',
  CAN_VIEW_OUTPUT_CHANNELS = 'view.notifications.output.channels',
  CAN_VIEW_PAYMENT_LINKS = 'view.direct.payment.links',
  CAN_VIEW_PAYMENT_PAGE_STYLIZATIONS = 'view.payment.page.stylizations',

  CAN_VIEW_PERMISSION_PICTURE = 'view.permission.picture',
  CAN_VIEW_PSP_BANK_TERMINALS = 'view.bank.terminals',
  CAN_VIEW_PSPS = 'view.banks',
  CAN_VIEW_RESULT_CODES = 'view.result.code.mapping',

  CAN_VIEW_ROUTING_SCHEMAS = 'view.single.routing.schema',
  CAN_VIEW_RULESET_STATS = 'view.rulesets.stats',

  CAN_VIEW_RULESETS = 'view.rulesets',
  CAN_VIEW_SETTLEMENT_CONTRACTS = 'view.settlement.contracts',
  CAN_VIEW_SETTLEMENT_CONTRACTS_WORKBOOK = 'view.settlement.contracts.workbook',
  CAN_VIEW_SINGLE_BANK_PARAMETER = 'view.single.bank.parameter',

  CAN_VIEW_SINGLE_LE_DOCUMENT = 'view.single.legal.entity.document',
  CAN_VIEW_SINGLE_PSP_TERMINAL_PARAMETER = 'view.single.bank.terminal.parameter',

  CAN_VIEW_SINGLE_TL_GROUP_LIMIT = 'view.single.terminal.link.group.limit',
  CAN_VIEW_SINGLE_TRANSACTION_OPERATION = 'view.single.transaction.operation',
  CAN_VIEW_TEMPLATES = 'view.notifications.message.templates',
  CAN_VIEW_TERMINAL_LINK_REQUIRED_PARAMETERS = 'view.terminal.link.required.parameters.configuration',

  CAN_CREATE_MANUAL_RECONCILIATION = 'create.manual.reconciliation',

  CAN_VIEW_TERMINAL_LINK_SETTLEMENT_CONFIGS = 'view.terminal.link.settlement.configs',
  CAN_VIEW_TERMINAL_LINKS = 'view.terminal.links',

  CAN_VIEW_TERMINAL_LINKS_ACTIONS = 'view.terminal.link.actions',

  CAN_VIEW_TERMINAL_LINKS_GROUPS = 'view.terminal.links.group',
  CAN_VIEW_TERMINAL_LINKS_LIMITS = 'view.terminal.links.limits',
  CAN_VIEW_TERMINAL_LINKS_PARAMETERS = 'view.terminal.links.parameters',
  CAN_VIEW_TERMINAL_OUTPUT_CHANNELS = 'view.mt.notifications.output.channels',

  CAN_VIEW_TRANSACTION_OPERATION_HISTORY = 'view.transactions.operation.history',
  CAN_VIEW_TRANSACTION_OPERATION_HISTORY_DETAILS = 'view.transactions.operation.history.details',
  CAN_VIEW_TRANSACTION_OPERATION_HISTORY_EXTRA_DETAILS = 'view.transactions.operation.history.extradetails',
  CAN_VIEW_TRANSACTION_ROUTING_HISTORY = 'view.transactions.routing.history',
  CAN_VIEW_TRANSACTIONS = 'view.transactions',

  CAN_GROUP_EDIT_USERS = 'group.edit.users',
  CAN_VIEW_USERS = 'view.users',
  CAN_VIEW_USERS_AUDIT_LOG = 'view.users.audit.log',
  CREATE_ADAPTER_CODE = 'create.builder.adapter.code',
  CREATE_LEGAL_ENTITY = 'create.legal.entity',
  CREATE_ORGANIZATION = 'create.organization',

  CREATE_ROLE = 'create.role',
  DELETE_LEGAL_ENTITY = 'delete.legal.entity',
  DELETE_ORGANIZATION = 'delete.organization',
  DELETE_ROLE = 'delete.role',

  UPDATE_LEGAL_ENTITY = 'update.legal.entity',
  UPDATE_ORGANIZATION = 'update.organization',
  UPDATE_ROLE = 'update.role',

  VIEW_ADAPTERS_CODES = 'view.builder.adapter.codes',
  VIEW_AUDIT_LOGS = 'view.audit.logs',
  VIEW_AUTH_AUDIT_LOGS = 'view.users.auth.audit',
  VIEW_EMAILS = 'view.emails',
  VIEW_FULL_BIN = 'view.fullbin',
  VIEW_LEGAL_ENTITIES = 'view.legal.entities',
  VIEW_ORGANIZATIONS = 'view.organizations',
  VIEW_PERMISSIONS = 'view.permissions',

  VIEW_PHONE_NUMBERS = 'view.phone.numbers',
  VIEW_ROLES = 'view.roles',

  CAN_VIEW_PAYMENT_INSTRUMENTS = 'view.payment.instruments',

  CAN_CREATE_MERCHANT_CUSTOM_ACTION = 'view.merchant.terminal.actions',
  CAN_DELETE_MERCHANT_CUSTOM_ACTION = 'update.merchant.terminal.action',
  CAN_UPDATE_MERCHANT_CUSTOM_ACTION = 'create.merchant.terminal.action',
  CAN_VIEW_MERCHANT_CUSTOM_ACTIONS = 'delete.merchant.terminal.action',

  CAN_CREATE_RECONCILIATION_FOLDER = 'create.recon.folder',
  CAN_CREATE_RECONCILIATION_REPORTS = 'create.reconciliation.reports',
  CAN_DELETE_RECONCILIATION_FOLDER = 'delete.recon.folder',
  CAN_UPDATE_RECONCILIATION_FOLDER = 'update.recon.folder',
  CAN_VIEW_RECONCILIATION_FOLDER = 'view.recon.folder',
  CAN_VIEW_RECONCILIATION_MAPPING = 'general.recon',

  CAN_RESOLVE_RECONCILIATION = 'reconciliation.resolve',
}
